import React, { useContext, useMemo } from "react";
import { ReactSVG } from "react-svg";

import { UserContext } from "../../UserContext";
import { openPopup } from "../Common/popupUIStore";
import useNotificationsUnread from "../../hooks/useNotificationsUnread";
import {
   toggleHomeEditing,
   useHomeEditing,
} from "../SPanel/Home/homeEditStore";

import profileIcon from "../../assets/svg/acc.svg";
import reservationsIcon from "../../assets/svg/mdi--calendar-text-outline.svg";
import notificationIcon from "../../assets/svg/mingcute--notification-line.svg";

function resolveStudentName(user) {
   const first = String(user?.firstName || "").trim();
   const last = String(user?.lastName || "").trim();
   const fromParts = `${first} ${last}`.trim();
   if (fromParts) return fromParts;

   const fallback = String(user?.name || user?.fullName || "").trim();
   return fallback || "Profil student";
}

/**
 * Bara de sus a elevului: profilul, rezervările, notificările și, pe pagina
 * principală, „Editează” (widget-urile). Pe telefon stă fixă sus pe toate
 * paginile elevului (AppShell); pe ecran lat apare doar pe pagina principală,
 * în pagină (`variant="inline"`).
 */
export default function StudentMobileTopBar({ variant = "fixed", showEdit = false }) {
   const { user } = useContext(UserContext);
   const fullName = useMemo(() => resolveStudentName(user), [user]);
   const { unreadCount } = useNotificationsUnread();
   const editing = useHomeEditing();

   const openProfile = () => openPopup("studentProfile");
   const openReservations = () => openPopup("studentReservations");
   const openNotifications = () => openPopup("notifications");

   return (
      <div
         className={
            "studentMobileTopBar" +
            (variant === "inline" ? " studentMobileTopBar--inline" : "")
         }
      >
         <div className="studentMobileTopBar__group studentMobileTopBar__group--left">
            <button
               type="button"
               className="studentMobileTopBar__btn studentMobileTopBar__btn--profile"
               onClick={openProfile}
               aria-label="Deschide profilul"
               title={fullName}
            >
               <span className="studentMobileTopBar__iconCircle">
                  <ReactSVG className="studentMobileTopBar__icon" src={profileIcon} />
               </span>
               <span className="studentMobileTopBar__name">
                  <p>{fullName}</p>
               </span>
            </button>
         </div>

         <div className="studentMobileTopBar__group studentMobileTopBar__group--right">
            <button
               type="button"
               className="studentMobileTopBar__btn studentMobileTopBar__btn--reservations"
               onClick={openReservations}
               aria-label="Deschide rezervările"
            >
               <ReactSVG className="studentMobileTopBar__icon" src={reservationsIcon} />
            </button>
            <button
               type="button"
               className="studentMobileTopBar__btn studentMobileTopBar__btn--notifications"
               onClick={openNotifications}
               aria-label="Deschide notificările"
            >
               <ReactSVG className="studentMobileTopBar__icon" src={notificationIcon} />
               {unreadCount > 0 ? (
                  <span
                     className="studentMobileTopBar__badge"
                     aria-hidden="true"
                  >
                     {unreadCount > 99 ? "99+" : unreadCount}
                  </span>
               ) : null}
            </button>
            {showEdit && (
               <button
                  type="button"
                  className={
                     "studentMobileTopBar__btn studentMobileTopBar__btn--edit" +
                     (editing ? " is-active" : "")
                  }
                  onClick={toggleHomeEditing}
                  aria-pressed={editing}
                  aria-label={editing ? "Gata cu aranjarea" : "Editează pagina"}
                  title={editing ? "Gata" : "Editează"}
               >
                  <svg className="studentMobileTopBar__svg" viewBox="0 0 24 24" aria-hidden="true">
                     {editing ? (
                        <path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" />
                     ) : (
                        <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z" />
                     )}
                  </svg>
               </button>
            )}
         </div>
      </div>
   );
}
